module.exports = __webpack_public_path__ + "static/media/20210411_150323_948_IMG_0456.5a346718.jpg";